// extracted by mini-css-extract-plugin
module.exports = {"checkboxContainer":"checkbox_checkboxContainer__Wu6zS","inactive":"checkbox_inactive__hsCIG","checkbox":"checkbox_checkbox__BzIb9","content":"checkbox_content__QAKFZ"};